/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import Link from "next/link";

import { LDFooter as Footer } from "src/components/Splash/Footer";
import { HeaderLink, LDHeaderWithBreadcrums } from "src/components/Splash/Header";
import { LDPageContainer } from "src/components/Splash/Layout/PageContainer";
import { AppRoutes } from "src/lib/constants";

interface Props {
  leftLink: string;
  leftLinkText: string;
  rightLink: string;
  rightLinkText: string;
  stem?: string | React.ReactNode; // default is "VIENNA /"
  stemLink?: AppRoutes; // default is AppRoutes.Meta
  pageName?: string | React.ReactNode; // default is "BLOG"
  pageNameLink?: AppRoutes; // default is AppRoutes.Blog
  children: React.ReactNode;
}

export function PostTemplate({
  leftLink,
  leftLinkText,
  rightLink,
  rightLinkText,
  stem,
  stemLink,
  pageName,
  pageNameLink,
  children,
}: Props) {
  return (
    <LDPageContainer>
      <LDHeaderWithBreadcrums
        stem={stem}
        stemLink={stemLink}
        text={pageName || " BLOG"}
        textLink={pageNameLink || AppRoutes.Blog}
        leftItem={
          <Link href={leftLink} passHref>
            <HeaderLink style={{ textAlign: "left", marginLeft: "20px" }}>{leftLinkText}</HeaderLink>
          </Link>
        }
        rightItem={
          <Link href={rightLink} passHref>
            <HeaderLink style={{ textAlign: "right", marginLeft: "20px" }}>{rightLinkText}</HeaderLink>
          </Link>
        }
      />
      {children}
      <Footer />
    </LDPageContainer>
  );
}

export interface PostAttrs {
  title: string;
  SEOtitle: string;
  date: string;
  slug: string;
  description: string;
}
